"use client";

import { ChevronDown } from "lucide-react";
import { useState, useCallback, useRef, useMemo } from "react";
import { useSearchParams, useRouter } from "next/navigation";

import styles from "./SubHeader.module.scss";
import Image from "next/image";

export const TagsAccordion = (props) => {
  const { tags } = props;

  const router = useRouter();
  const searchParams = useSearchParams();

  const selectedTagIds = useMemo(() => {
    const params = {};

    for (const [key, value] of searchParams.entries()) {
      const match = key.match(/^(\w+)\[(\d+)\]$/);
      if (match) {
        const paramName = match[1];
        const index = Number(match[2]);

        if (!params[paramName]) {
          params[paramName] = [];
        }

        params[paramName][index] = value;
      } else {
        params[key] = value;
      }
    }

    return params.tagIds || [];
  }, [searchParams]);

  const [isOpen, setIsOpen] = useState(false);

  const contentRef = useRef(null);

  const toggleAccordion = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, [setIsOpen]);

  const handleTagToggle = useCallback(
    (tagId) => {
      const newSearchParams = new URLSearchParams(searchParams);

      for (const [key] of searchParams.entries()) {
        if (key.startsWith("tagIds")) {
          newSearchParams.delete(key);
        }
      }

      if (selectedTagIds.find((tId) => tId == tagId)) {
        router.replace(`/blog?${newSearchParams.toString()}`);
        return;
      }

      setIsOpen(false);

      const foundTag = tags.find((tag) => tag.id == tagId);

      const newSelectedTagIds = foundTag ? [foundTag.id] : [];

      newSelectedTagIds.forEach((tagId, idx) =>
        newSearchParams.append(`tagIds[${idx}]`, tagId),
      );

      router.replace(`/blog?${newSearchParams.toString()}`);

      setIsOpen(false);
    },
    [searchParams, router, selectedTagIds, setIsOpen, tags],
  );

  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <div data-open={isOpen} className={styles.accordion__wrapper}>
      <button onClick={toggleAccordion}>
        <h3>hashtags</h3>

        <ChevronDown />
      </button>

      <div
        style={{
          maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : 0,
        }}
      >
        <div ref={contentRef}>
          {tags.map((tag) => (
            <button
              key={tag.id}
              onClick={() => handleTagToggle(tag.id)}
              data-selected={!!selectedTagIds.find((tagId) => tagId == tag.id)}
            >
              <Image
                src="/images/hashtag.svg"
                alt="tag"
                width={20}
                height={20}
              />
              <p className={styles.tag__text}>{tag.text}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
